import { SkeletonLoader } from 'common/react/components/SkeletonLoader';
import { SvgIcon } from 'common/react/components/SvgIcon';
import React, { Fragment } from 'react';

const ROW_DISPLAY_COUNT = 15,
    SQUARES_DISPLAY_COUNT_DESKTOP = 25, // 24 Rounds, 1 Total
    SQUARES_DISPLAY_COUNT_TABLET = 20,
    SQUARES_DISPLAY_COUNT_PHABLET = 15,
    SQUARES_DISPLAY_COUNT_MOBILE = 10;

/**
 * Displays a skeleton loader for the Player Awards Leaderboard table.
 *
 * @returns {JSX.Element} The Player Awards Leaderboard table skeleton loader.
 */
export const LeaderboardTableSkeleton = () => {
    return (
        <div className="player-awards-tracker-leaderboard-skeleton">
            <div className="stats-table__table">
                <div className="stats-table__header-row--leader stats-table__header-row stats-table__body-row u-hide-from-desktop">
                    <div className="stats-table__header-row stats-table__row-header-cell stats-table__row-header-cell-name">
                        <SvgIcon
                            icon="player-stats"
                            className="stats-table__row-header-cell-avatar"
                        />
                        <SkeletonLoader height={16} width={150} />
                    </div>
                    <div className="stats-table__header-row stats-table__row-header-cell stats-table__row-header-cell-votes">
                        <SkeletonLoader height={32} />
                    </div>
                </div>

                <div className="stats-table__header-row stats-table__body-row--leader u-hide-until-tablet u-hide-from-desktop">
                    <div className="stats-table__row-header-cell stats-table__row-header-cell-votes">
                        {Array.from({
                            length: SQUARES_DISPLAY_COUNT_TABLET
                        }).map((_, index) => (
                            <SkeletonLoader
                                key={`stats-table__row-header-cell-votes-tablet__${index}`}
                                height={32}
                            />
                        ))}
                    </div>
                </div>

                <div className="stats-table__header-row stats-table__body-row--leader u-hide-until-phablet u-hide-from-tablet">
                    <div className="stats-table__row-header-cell stats-table__row-header-cell-votes">
                        {Array.from({
                            length: SQUARES_DISPLAY_COUNT_PHABLET
                        }).map((_, index) => (
                            <SkeletonLoader
                                key={`stats-table__row-header-cell-votes-phablet__${index}`}
                                height={32}
                            />
                        ))}
                    </div>
                </div>

                <div className="stats-table__header-row stats-table__body-row--leader u-hide-from-phablet">
                    <div className="stats-table__row-header-cell stats-table__row-header-cell-votes">
                        {Array.from({
                            length: SQUARES_DISPLAY_COUNT_MOBILE
                        }).map((_, index) => (
                            <SkeletonLoader
                                key={`stats-table__row-header-cell-votes-mobile__${index}`}
                                height={32}
                            />
                        ))}
                    </div>
                </div>

                <div className="stats-table__header-row u-hide-until-desktop">
                    <SkeletonLoader height={48} />
                </div>

                {/* Render standard rows */}
                {Array.from({ length: ROW_DISPLAY_COUNT }, (_, index) => (
                    <Fragment key={`stats-table__row__${index}`}>
                        {tableRow()}
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

/**
 * Renders a table row.
 *
 * @param {number} index  The index position value.
 * @returns {JSX.Element} The table row.
 */
const tableRow = () => {
    return (
        <div className="stats-table__body-row">
            <div className="stats-table__row-header-cell stats-table__row-header-cell-name">
                <SvgIcon
                    icon="player-stats"
                    className="stats-table__row-header-cell-avatar"
                />
                <SkeletonLoader height={16} width={150} />
            </div>
            <div className="stats-table__row-header-cell stats-table__row-header-cell-votes u-hide-until-desktop">
                {Array.from({ length: SQUARES_DISPLAY_COUNT_DESKTOP }).map(
                    (_, index) => (
                        <SkeletonLoader
                            key={`stats-table__row-header-cell-votes-desktop__${index}`}
                            height={32}
                        />
                    )
                )}
            </div>
        </div>
    );
};
